/** Roluri utilizator. `admin` = acces total; `operator` = operare curentă. */
export const ROLES = ['admin', 'operator'];
export function isRole(v) {
    return typeof v === 'string' && ROLES.includes(v);
}
//# sourceMappingURL=roles.js.map